const ProjectsManager = {
  store: (data) => {
    localStorage.setItem("projects", JSON.stringify(data));
  },

  update: (data) => {
    let dataManager = ProjectsManager.get();

    if (!dataManager) {
      dataManager = {}; // Inicializamos si no hay nada aún
    }

    for (let prop in data) {
      dataManager[prop] = data[prop];
    }

    ProjectsManager.store(dataManager);
  },

  destroy: () => {
    localStorage.removeItem("projects");
  },

  get() {
    return JSON.parse(localStorage.getItem("projects"));
  },

  // Guarda este estado en base a la cantidad de compras que obtiene cuando se abre el modal (DialogAssignPurchases).
  // Se utiliza para mostrar/ocultar una card que invita al usuario al directorio y a realizar una cotización.
  setHasPurchasesToAssign(value) {
    this.update({ has_purchases_to_assign: value });
  },

  hasPurchasesToAssign() {
    // Guard against null (no projects in localStorage)
    return this.get()?.has_purchases_to_assign ?? null;
  },

  setQuotePhone(phone) {
    if (!phone) return;

    this.update({ quote_phone: phone });
  },

  getQuotePhone() {
    // Guard against null (no projects in localStorage)
    return this.get()?.quote_phone ?? null;
  },
};

export default ProjectsManager;
